import { gateNames, useGate } from '@mp';
import { useMatch } from 'react-router-dom';

export const useIsApplicationVideoHeader = (): boolean => {
  const isApplicationRoute = useMatch('/application/*');
  const isProAppVideoEnabled = useGate(gateNames.proAppVideo);

  return Boolean(isApplicationRoute) && isProAppVideoEnabled;
};
